export default {
  "nav.brand": "USFANSLINK",
  "nav.home": "Inicio",
  "nav.guide": "Guía completa",
  "nav.shoppingGuide": "Guía de compra",
  "nav.visitMain": "Visitar el sitio principal",

  "hero.eyebrow": "Recurso del Spreadsheet de USFANS",
  "hero.title": "USFANS Spreadsheet — Encuentra productos, vendedores y recursos de compra más rápido",
  "hero.subtitle": "¿Buscas el spreadsheet de USFANS? Explora recursos de productos organizados, información de vendedores, guías de compra, consejos de control de calidad, información de envío, recursos de almacén y las últimas novedades de USFANS — todo en un solo lugar.",
  "hero.ctaPrimary": "usfans spreadsheet",
  "hero.ctaSecondary": "buy it now",
  "hero.trust": "Recurso informativo independiente • Actualizado con frecuencia • Pensado para investigar productos con facilidad",

  "dropdown.label": "Explorar categorías",
  "dropdown.placeholder": "Elige una categoría…",

  "categories.title": "Comprar por categoría",
  "categories.subtitle": "Ve directo a cualquier categoría de productos del sitio principal. Cada enlace se abre en una pestaña nueva.",
  "categories.shoes": "Zapatos",
  "categories.hoodies": "Sudaderas / Jerséis",
  "categories.tshirts": "Camisetas",
  "categories.jackets": "Chaquetas",
  "categories.pants": "Pantalones / Pantalones cortos",
  "categories.headwear": "Gorros y sombreros",
  "categories.sets": "Conjuntos",
  "categories.underwear": "Ropa interior / Calzoncillos",
  "categories.jersey": "Camisetas deportivas",
  "categories.accessories": "Accesorios",
  "categories.bags": "Bolsos",
  "categories.belts": "Cinturones",
  "categories.perfumes": "Perfumes",
  "categories.other": "Otras cosas",
  "categories.open": "Abrir",

  "features.title": "Todo lo que necesitas para moverte por el Spreadsheet de USFANS",
  "features.subtitle": "Un recurso organizado que te ayuda a pasar de explorar a decidir con seguridad.",
  "features.f1.title": "Encuentra productos más rápido",
  "features.f1.text": "Descubre recursos de productos y categorías organizados sin perder tiempo buscando entre información dispersa.",
  "features.f2.title": "Compara vendedores",
  "features.f2.text": "Aprende qué revisar al evaluar vendedores, información de productos y recursos disponibles.",
  "features.f3.title": "Entiende el envío",
  "features.f3.text": "Explora la información de envío de USFANS, los costes, los métodos y las consideraciones importantes antes de pedir.",
  "features.f4.title": "Comprueba antes de comprar",
  "features.f4.text": "Usa las guías de control de calidad, almacén, seguridad y compra para decidir mejor.",

  "teaser.eyebrow": "Guía destacada",
  "teaser.title": "La guía completa del Spreadsheet de USFANS",
  "teaser.text": "Aprende qué es el spreadsheet de USFANS, cómo usarlo y qué revisar antes de comprar — desde la investigación de vendedores hasta el envío, el control de calidad y la seguridad.",
  "teaser.cta": "Leer la guía completa",

  "faq.title": "Preguntas frecuentes sobre el Spreadsheet de USFANS",
  "faq.q1": "¿Qué es el spreadsheet de USFANS?",
  "faq.a1": "Es un recurso organizado que agrupa categorías de productos, notas de vendedores e información de compra en una sola lista estructurada, para que explores productos más rápido en lugar de buscar página por página.",
  "faq.q2": "¿Cómo uso el spreadsheet de USFANS?",
  "faq.a2": "Empieza por la categoría que necesitas, lee las notas del vendedor, compara algunas opciones, revisa el envío y abre el enlace del producto en una pestaña nueva para seguir en el sitio principal.",
  "faq.q3": "¿Es legítimo USFANS?",
  "faq.a3": "Somos un recurso independiente y no podemos verificar a cada vendedor o producto. Revisa siempre la información actual, las reseñas y las condiciones de envío antes de comprar.",
  "faq.q4": "¿Cuánto cuesta el envío de USFANS?",
  "faq.a4": "Los costes de envío cambian según el destino, el peso y el método, por lo que aquí no publicamos precios fijos. Revisa la información de envío actual en el sitio principal antes de pedir.",

  "cta.title": "¿Listo para explorar el Spreadsheet de USFANS?",
  "cta.text": "Empieza por el hub del spreadsheet, explora las últimas guías y compara recursos útiles antes de visitar el sitio principal.",
  "cta.primary": "Explorar el Spreadsheet de USFANS",
  "cta.secondary": "Leer la guía",

  "footer.disclaimerTitle": "Aviso legal",
  "footer.disclaimer": "Este sitio web es un recurso informativo independiente. No garantizamos vendedores, productos, resultados de envío, reembolsos, transacciones ni plazos de entrega. Verifica siempre la información actual antes de comprar.",
  "footer.explore": "Explorar",
  "footer.company": "Empresa",
  "footer.guide": "Guía completa",
  "footer.rights": "Todos los derechos reservados.",
  "footer.language": "Idioma",

  "guides.title": "Guías y recursos de USFANS",
  "guides.subtitle": "Guías independientes y originales para investigar productos, comparar vendedores y comprar con confianza.",
  "guides.readMore": "Leer la guía",
  "article.notFound": "Guía no encontrada",

  "nav.about": "Acerca de",
  "nav.contact": "Contacto",
  "nav.privacy": "Política de privacidad",
  "nav.editorial": "Política editorial",

  "contact.title": "Contáctanos",
  "contact.subtitle": "¿Tienes una pregunta o comentario? Envíanos un mensaje y te responderemos.",
  "contact.name": "Nombre",
  "contact.email": "Correo electrónico",
  "contact.message": "Mensaje",
  "contact.submit": "Enviar mensaje",
  "contact.sending": "Enviando...",
  "contact.success": "¡Gracias! Tu mensaje ha sido enviado.",
  "contact.error": "Algo salió mal. Inténtalo de nuevo.",

  "article.reviewedBy": "Revisado por",
  "article.lastUpdated": "Última actualización",

  "notFound.title": "Página no encontrada",
  "notFound.text": "La página que buscas no existe o ha sido movida.",
};